export default __webpack_public_path__ + "static/media/pic4.b9472dfa.png";